import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom"; // 👈 Importa el hook
import useModalModulo from "../hooks/useModalModulo"; // Ajusta ruta

const icons = [
  { titulo: "Siniestralidad", valor: "siniestralidad" },
  { titulo: "Permisos", valor: "permisos" },
  { titulo: "Capacitación", valor: "capacitacion" },
  { titulo: "Cotizador", valor: "cotizador" },
  { titulo: "Whatsapp", valor: "whatsapp" },
  { titulo: "Configuración", valor: "configuración" },
  { titulo: "Estadísticas", valor: "estadísticas" },
  { titulo: "Control carretero", valor: "carretero" },
  { titulo: "Formal reclamación", valor: "formalreclamación" },
  { titulo: "Control obras", valor: "controlobras" },
];

const initialForm = {
  Id: 0,
  Titulo: "",
  URL: "",
  Win: false,
  Clavep: "",
  Icono: "",
};

const ModalModulo = ({ datos = [], isOpen, onClose, selectedItem, onSave }) => {
  const [mensajeGuardado, setMensajeGuardado] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");

  // Obtener el callback del layout si existe
  const { handleModuloSave } = useOutletContext() || {};

  const {
    formmodulos,
    handleChange,
    handleSubmit: handleSubmitOriginal,
    resetForm,
    handleBlur,
    setFormmodulos,
  } = useModalModulo(selectedItem || initialForm);

  useEffect(() => {
    resetForm();
    setMensajeGuardado(false);
    setIsSaving(false);
    setError("");
  }, [selectedItem, isOpen]);

  if (!isOpen) return null;

  const renderOptions = (menus, nivel = 0) => {
    if (nivel >= 3) return null;

    return menus.map((menu) => (
      <React.Fragment key={menu.Clave}>
        <option value={menu.Clave}>
          {"-".repeat(nivel)} {menu.Titulo}
        </option>
        {menu.Menus?.length > 0 && renderOptions(menu.Menus, nivel + 1)}
      </React.Fragment>
    ));
  };

  const onWinChange = (e) => {
    const val = e.target.value === "true";
    setFormmodulos((prev) => ({
      ...prev,
      Win: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación: si Win es true, URL no puede estar vacío
    if (formmodulos.Win && formmodulos.URL.trim() === "") {
      setError("Debe ingresar una URL si el módulo crea ventana nueva.");
      return;
    }

    setError("");
    setIsSaving(true);
    await handleSubmitOriginal(e);
    setIsSaving(false);
    setMensajeGuardado(true);

    if (handleModuloSave) handleModuloSave(); // Layout (si existe)
    if (typeof onSave === "function") onSave(); // Componente padre

    setTimeout(() => {
      setMensajeGuardado(false);
      onClose();
    }, 200);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-md shadow-lg min-w-[65rem] w-full max-w-md"
      >
        <div className="bg-sidebar-200 rounded-t-md text-white pl-4 pt-1 font-bold h-[2rem]">
          {formmodulos.Id === 0 ? "Agregar módulo" : "Editar módulo"}
        </div>

        <div className="mb-4 px-3 pt-2">
          <label className="block mb-1 font-semibold">Nombre del módulo:</label>
          <input
            type="text"
            name="Titulo"
            value={formmodulos.Titulo}
            onChange={handleChange}
            onBlur={handleBlur}
            className="max-w-[35rem] border border-gray-300 rounded px-3 py-2"
            autoComplete="off"
          />
        </div>

        <div className="mb-4 px-3">
          <label className="block mb-1 font-semibold">Módulo padre:</label>
          <select
            name="Clavep"
            value={formmodulos.Clavep}
            onChange={handleChange}
            className="max-w-[35rem] border border-gray-300 rounded px-3 py-2"
          >
            <option value="">--- Ninguno ---</option>
            {renderOptions(datos)}
          </select>
        </div>

        <div className="mb-4 px-3">
          <label className="block mb-1 font-semibold">
            ¿Desea que el módulo cree ventana nueva?
          </label>
          <select
            name="Win"
            value={formmodulos.Win ? "true" : "false"}
            onChange={onWinChange}
            className="w-[5rem] border border-gray-300 rounded px-3 py-2"
          >
            <option value="false">NO</option>
            <option value="true">SI</option>
          </select>
        </div>

        <div className="mb-4 px-3">
          <label
            className={`block mb-1 font-semibold `}
          >
            URL (Looker Studio / Google Sheet / Sitio Web):
          </label>
          <input
            type="text"
            name="URL"
            value={formmodulos.URL}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`w-full border border-gray-300 rounded px-3 py-2 `}
            autoComplete="off"
            
          />
        </div>

        <div className="mb-4 px-3">
          <label className="block mb-1 font-semibold">Seleccionar ícono:</label>
          <select
            name="Icono"
            value={formmodulos.Icono}
            onChange={handleChange}
            className="max-w-[20rem] border border-gray-300 rounded px-3 py-2"
          >
            <option value="">--- Seleccionar Ícono ---</option>
            {icons.map((icon) => (
              <option key={icon.valor} value={icon.valor}>
                {icon.titulo}
              </option>
            ))}
          </select>
        </div>

        {isSaving && (
          <div className="text-blue-600 font-semibold px-3 pb-2 flex items-center gap-2">
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-blue-500 border-solid"></div>
            {formmodulos.Id === 0 ? "Guardando módulo..." : "Actualizando módulo..."}
          </div>
        )}

        {mensajeGuardado && (
          <div className="text-green-600 font-semibold px-3 pb-2 transition-opacity duration-500 ease-in-out opacity-100">
            Cambios guardados correctamente ✅
          </div>
        )}

        {error && (
          <div className="text-red-600 font-semibold px-3 pb-2">{error}</div>
        )}

        <div className="flex justify-end gap-2 pb-3 pr-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isSaving}
            className="px-4 py-2 bg-gray-400 rounded hover:bg-gray-500 text-white"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={isSaving}
            className={`px-4 py-2 text-white rounded ${
              isSaving ? "bg-green-400" : "bg-green-700 hover:bg-green-600"
            }`}
          >
            {formmodulos.Id === 0 ? "Guardar" : "Actualizar"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ModalModulo;
